import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
export default class BarcodeService extends BaseService {
  async fetch(companyUuid, { filters, order, pagination }) {
    const url = `/v1/companies/${companyUuid}/barcodes`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination
    });
    return await this.get(resourceRoute);
  }

  async fetchByUuid(companyUuid, barcodesUuid) {
    return await this.get(
      `/v1/companies/${companyUuid}/barcodes/${barcodesUuid}`
    );
  }

  async updateBarcode(companyUuid, barcodesUuid, params) {
    return await this.update(
      `/v1/companies/${companyUuid}/barcodes/${barcodesUuid}`,
      params
    );
  }

  async createBarcode(companyUuid, params) {
    return await this.post(`/v1/companies/${companyUuid}/barcodes`, params);
  }

  async create(companyUuid, params) {
    return await this.post(`/v1/companies/${companyUuid}/barcodes`, params);
  }

  async deleteBarcode(companyUuid, barcodesUuid) {
    return await this.destroy(
      `/v1/companies/${companyUuid}/barcodes/${barcodesUuid}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/service/barcode.service.js